import { createSlice } from '@reduxjs/toolkit';
import { ShippingHistoryState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { shippingHistoryThunk } from './thunks';

// Initial State
const initialState: ShippingHistoryState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const shippingHistorySlice = createSlice({
  name: 'shippingHistory',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(shippingHistoryThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });

    builder.addCase(shippingHistoryThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });

    builder.addCase(shippingHistoryThunk.rejected.type, (state, { payload }: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset } = shippingHistorySlice.actions;
export * from './thunks';
export * from './selectors';
export * from './types';
export default shippingHistorySlice.reducer;
